import { NotificationMessageType } from '../NotificationMessageType';

export interface GenericNotificationMessage {
  SentUTC: string;
  MessageId: string;
  EntityId: string;
  Type: NotificationMessageType;
  MessageValues: string[];
}

// Converts JSON strings to/from your types
export class Convert {
  public static toGenericNotification(json: string): GenericNotificationMessage {
    return JSON.parse(json);
  }

  public static genericNotificationToJson(value: GenericNotificationMessage): string {
    return JSON.stringify(value);
  }
}
